// extracted by mini-css-extract-plugin
module.exports = {"serviceHeaderImage":"bank-account-opening_serviceHeaderImage__BEEku"};